import React from 'react';
import {
  Modal,
  ModalFooter,
  ModalHeader,
  ModalSection,
  Paragraph,
  Button,
} from '@axiom/ui';
import type { Candidate } from '@axiom/validation';

import { CandidateCommunicationAlertsApi } from '../../api/candidate-communication-alerts-api';
import { CandidateApi } from '../../api/candidate-api';

export type PreferencesMfaPhoneDeleteModalProps = {
  name?: string;
  candidateId: Candidate['id'];
  onClose: () => void;
};

export const PreferencesMfaPhoneDeleteModal = ({
  name = 'PREFERENCES_MFA_PHONE_DELETE_MODAL',
  candidateId,
  onClose,
}: PreferencesMfaPhoneDeleteModalProps) => {
  return (
    <Modal name={name} size="confirm">
      <ModalHeader
        name={`${name}_HEADER`}
        onClose={() => {
          onClose();
        }}
      >
        Delete phone number
      </ModalHeader>
      <ModalSection>
        <Paragraph>
          This will permanently delete your two-factor authentication phone
          number. You can add a new phone number at any time.
        </Paragraph>
      </ModalSection>
      <ModalFooter>
        <Button
          name="CANCEL_BUTTON"
          variation="outline"
          onClick={() => {
            onClose();
          }}
        >
          Cancel
        </Button>
        <Button
          name="DELETE_BUTTON"
          onClick={async () => {
            await CandidateApi.deleteNotificationsPhoneNumber(candidateId);
            await CandidateApi.refreshCandidateMfaPhoneNumber(candidateId);
            await CandidateCommunicationAlertsApi.refreshCommunicationAlerts(
              candidateId
            );
            onClose();
          }}
        >
          Delete
        </Button>
      </ModalFooter>
    </Modal>
  );
};
